import { EntityTypeAndId, IntelligenceEntityType } from '../types'

const usptoMeta: EntityTypeAndId = {
  entity: IntelligenceEntityType.Uspto,
  id: '0',
}

export default usptoMeta
